import { Routes } from '@angular/router';
import { RealtimeTrackingComponent } from './realtime-tracking.component';
import { AuthGuard } from '@auth0/auth0-angular';
import { LoadTrackingGuard } from '../core/guards/load-tracking.guard';
import { TrackATripComponent } from './track-a-trip/track-a-trip.component';
import { LoadTrackingMonitoringComponent } from './load-tracking-monitoring/load-tracking-monitoring.component';
import { TrackATripIntegrationComponent } from './track-a-trip-intergration/track-a-trip-integration.component';
import { LanguageResolver } from '../shared/resolvers/language.resolver';

export const REALTIME_TRACKING_ROUTES: Routes = [
  {
    path: 'realtime-tracking', data: { loadTrackingView: true }, component: RealtimeTrackingComponent, canActivate: [AuthGuard], children: [
      { path: 'overview', component: LoadTrackingMonitoringComponent, canActivate: [LoadTrackingGuard], data: { overviewActive: true } },
      { path: 'map', component: LoadTrackingMonitoringComponent, canActivate: [LoadTrackingGuard], data: { overviewActive: false } },
      { path: '**', redirectTo: '' }
    ]
  },
  {
    path: 'customer',
    data: { loadTrackingView: true, customerView: true },
    resolve: {
      language: LanguageResolver
    },
    children: [
      { path: 'track-a-trip/:id', component: TrackATripComponent }
    ]
  },
  {
    path: 'integration',
    data: { loadTrackingView: true, customerView: true },
    resolve: {
      language: LanguageResolver
    },
    children: [
      { path: ':serviceName/track-a-trip', component: TrackATripIntegrationComponent }
    ]
  }
];
